import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, NgModel } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { stateOptionsSample, dosageFormulationOptionsConstant } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import * as $ from 'jquery';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
@Component({
  selector: 'app-eap-return-retrival-modal',
  templateUrl: './eap-return-retrival-modal.component.html',
  styleUrls: ['./eap-return-retrival-modal.component.scss']
})
export class EapReturnRetrivalModalComponent implements OnInit {

  formFields;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  formData: FormData;
  retrivalRequestForm: UntypedFormGroup;
  @Input() public Content: any;
  staticformFields: any;
  typeList:any=[];

  optionsSelect = stateOptionsSample;
  dosageFormulationOptionsConstant = dosageFormulationOptionsConstant;


  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private commonService: CommonService
  ) {
  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode,this.Content.content.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }
  ngOnInit() {
    this.getStaticFiledsData('SCR-019');
    this.retrivalRequestForm = new UntypedFormGroup({
      RETRIVE_RETURN_QUANTITY: new UntypedFormControl("", [Validators.required]),
      RETRIVE_RETURN_QUANTITY_UNIT: new UntypedFormControl(""),
      RETRIVE_NOTES: new UntypedFormControl('')
    });
    this.retrivalRequestForm.controls["RETRIVE_RETURN_QUANTITY"].disable();
    this.retrivalRequestForm.controls["RETRIVE_RETURN_QUANTITY"].setValue(this.Content.content.ReturnAmount);
  }

  save() {
    if (this.ValidateControls()) {
      var formData = this.retrivalRequestForm.getRawValue();
      formData["RETRIVE_RETURN_QUANTITY"] = parseInt(formData["RETRIVE_RETURN_QUANTITY"]);
      formData["ProductID"] = this.Content.content.id;
      this.summaryService.Insert("api/EAPAllRequests/UpdateRetrivalStatus", formData).subscribe(result => {
      this.modalRef.close();
      });

    }
  }

  ValidateControls(): boolean {
    let isValid: boolean = true;
    let message = "";
    let RETRIVE_RETURN_QUANTITY = $("#RETRIVE_RETURN_QUANTITY").val();

    if (RETRIVE_RETURN_QUANTITY == null || RETRIVE_RETURN_QUANTITY == "" || RETRIVE_RETURN_QUANTITY == undefined) {
      $("#RETRIVE_RETURN_QUANTITY").addClass("ng-touched ng-invalid validate-error");
      $("#RETRIVE_RETURN_QUANTITY").removeClass("ng-untouched ng-valid");
      message += "Please enter Return Quantity.<br/>";
      isValid = false;
    }
    else {
      $("#RETRIVE_RETURN_QUANTITY").addClass("ng-untouched ng-valid");
      $("#RETRIVE_RETURN_QUANTITY").removeClass("ng-touched ng-invalid validate-error");
    }

    if (RETRIVE_RETURN_QUANTITY !== null && RETRIVE_RETURN_QUANTITY !== "" && RETRIVE_RETURN_QUANTITY !== undefined) {
      const phoneformat = /^[1-9]\d*$/;
      RETRIVE_RETURN_QUANTITY = RETRIVE_RETURN_QUANTITY + "";
      if (RETRIVE_RETURN_QUANTITY.match(phoneformat)) {
        $("#RETRIVE_RETURN_QUANTITY").addClass("ng-untouched ng-valid");
        $("#RETRIVE_RETURN_QUANTITY").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#RETRIVE_RETURN_QUANTITY").addClass("ng-touched ng-invalid validate-error");
        $("#RETRIVE_RETURN_QUANTITY").removeClass("ng-untouched ng-valid");
        message += "Please enter Valid Return Quantity.<br/>";
        isValid = false;
      }
      var floatRerive = parseFloat(RETRIVE_RETURN_QUANTITY);
      var allocated = parseFloat(this.Content.content.Allocated);
      if (floatRerive > allocated) {
        $("#RETRIVE_RETURN_QUANTITY").addClass("ng-touched ng-invalid validate-error");
        $("#RETRIVE_RETURN_QUANTITY").removeClass("ng-untouched ng-valid");
        message += "Return Quantity should be less than Allocated Quantity.<br/>";
        isValid = false;
      }

    }

    if (!isValid)
    this.commonService.ValidationBanner(message)
    return isValid;
  }


}
